import { configureStore } from "@reduxjs/toolkit";
import superadminAuth from "./superadminAuth.slice.js"
import employeeAuth from "./employeeAuth.slice.js"
import reload from "./reload.slice.js"
import adminRole from "./adminRole.slice.js"

export const store = configureStore({
    reducer: {
        superadmin: superadminAuth,
        employee: employeeAuth,
        reload: reload,
        adminRole: adminRole
    }
});
